import { SetFieldFn } from "../../data";
import { aufgabenStyles } from "../../../styles/aufgaben/aufgaben.styles";
import {Box, FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import SearchField from "../../SearchField";
import { useUpdateSearchParam } from "../../../hooks/useUpdateSearchParams";
import { useMemo } from "react";

export type FreedaysFilter = {
  search?: string;
  filtered?: string;
  year?: number;
  countryCode?: string;
};

interface FilterTableFreedaysProps {
  search?: string;
  year?: number;
  countryCode?: string;
  setField: SetFieldFn<FreedaysFilter>;
}

export default function FilterTableFreedays({ search, year, countryCode, setField }: FilterTableFreedaysProps) {
  const updateSearchParam = useUpdateSearchParam();

  const handleSearchChange = (searchString: string) => {
    setField("search", searchString);
    updateSearchParam("search", searchString);
  };

  const years = useMemo(() => {
    const current = new Date().getFullYear();
    const from = current - 2;
    const to = current + 1;
    return Array.from({ length: to - from + 1 }, (_, i) => from + i);
  }, []);

  const handleYearChange = (value: string) => {
    const parsed = value ? parseInt(value, 10) : undefined;
    setField("year", parsed as any);
    updateSearchParam("year", value ?? "");
  };

  const handleCountryCodeChange = (value: string) => {
    setField("countryCode",value);
    updateSearchParam("countryCode", value ?? "");
  };

  return (
    <Box sx={{ ...aufgabenStyles.filterTableAufgaben.box, gap: 2, display: "flex", alignItems: "center" }}>
      <SearchField value={search ?? ""} onChange={(searchString: string) => handleSearchChange(searchString)} />

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <FormControl size="small" sx={{ minWidth: 100 }}>
          <InputLabel id="year-label" shrink>Jahr</InputLabel>
          <Select
              labelId="year-label"
              label="Jahr"
              size="small"
              value={year ? String(year) : ""}
              displayEmpty
              notched
              onChange={(e) => handleYearChange(e.target.value as string)}
              sx={{ minWidth: 100 }}
          >
            <MenuItem value="">
              <em>Alle</em>
            </MenuItem>
            {years.map((y) => (
                <MenuItem key={y} value={String(y)}>
                  {y}
                </MenuItem>
            ))}
          </Select>
        </FormControl>

      </Box>

      <TextField
        size="small"
        label={"Vorwahl"}
        value={countryCode ?? ""}
        onChange={(e) => handleCountryCodeChange(e.target.value)}
        placeholder={"z. B. +49"}
      />
    </Box>
  );
}